import React from 'react';
import { TrinitiDateTimeCore } from './TrinitiDateTimeCore';

// Shared TrinitiCare Option 1 date/time selection system.
// Value contract (drop-in for the native inputs they replace):
//   date      -> "yyyy-MM-dd"
//   time      -> "HH:mm"
//   datetime  -> "yyyy-MM-ddTHH:mm"
// Single modes: value (string) + onChange(nextString)
// Range modes:  startValue/endValue (strings) + onChange({ start, end })

export function TrinitiDatePicker(props) {
  return <TrinitiDateTimeCore {...props} mode="date" />;
}
export function TrinitiTimePicker(props) {
  return <TrinitiDateTimeCore {...props} mode="time" />;
}
export function TrinitiDateTimePicker({ mode = 'datetime', ...rest }) {
  return <TrinitiDateTimeCore {...rest} mode={mode} />;
}
export function TrinitiDateRangePicker(props) {
  return <TrinitiDateTimeCore {...props} mode="date-range" />;
}
export function TrinitiDateTimeRangePicker(props) {
  return <TrinitiDateTimeCore {...props} mode="datetime-range" />;
}

export { TrinitiDateTimeCore };
export * from './dateUtils';
